import {
  DeviceId,
  Manufacturer,
  type DeviceType as UBIFDeviceType,
} from '@service-initiation/shared-clients-tech-care-services';

export const isEligibleForColorOptions = (device: UBIFDeviceType) =>
  device?.manufacturer === Manufacturer.Samsung ||
  device?.parent_device_type_id === DeviceId.Samsung;
